import { BackendModel, BackendService } from '../../core/backend.service';

export class Talle extends BackendModel {

  static path = '/productos/talles/';

  id: number;
  description: string;
  orden: number;

  constructor(protected backendService: BackendService, model?: Talle) {
    super(backendService, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/talle/talle.model.ts